export const environment = {
  heading: 'Development',
  production: false,
  apiUrl: 'https://api.dev.gateway.tourboplus.com/v2/tourbook',
  delegatoragencyid: '',
  delegatorid: '',
  xapikey: '123456',
  mpPublicKey: 'APP_USR-66f4db42-6331-4625-a2cb-3759f841b8d5',
};
